"use strict";

exports.__esModule = true;
exports.MetricChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _d3Scale = require("d3-scale");
var _Catalogs = require("../../../Catalogs");
var _scales = require("../../Charts/scales");
var _Axis = require("../../Charts/Axis");
var _Series = require("../../Charts/Series");
var _Time = require("../../Time");
var _dec, _class, _MetricChart;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows one or more metrics on a chart.
 */
var MetricChart = exports.MetricChart = (_dec = _Time.TimeContext.withContext, _dec(_class = (_MetricChart = /*#__PURE__*/function (_Component) {
  function MetricChart() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.createXScale = function (from, to) {
      var _this$props = _this.props,
        interval = _this$props.interval,
        series = _this$props.series;
      if (interval) {
        return (0, _scales.createIntervalScale)(from, to, interval);
      }
      var collected = new Set();
      for (var _iterator = _createForOfIteratorHelperLoose(series), _step; !(_step = _iterator()).done;) {
        var data = _step.value.data;
        for (var _iterator2 = _createForOfIteratorHelperLoose(data), _step2; !(_step2 = _iterator2()).done;) {
          var key = _step2.value.key;
          collected.add(Date.parse(key));
        }
      }
      return (0, _scales.createTimeScale)(from, to, Array.from(collected).sort());
    };
    _this.createYScales = function (from, to) {
      var series = _this.props.series;
      var unitRanges = [];
      for (var _iterator3 = _createForOfIteratorHelperLoose(series), _step3; !(_step3 = _iterator3()).done;) {
        var item = _step3.value;
        var metric = (0, _Catalogs.getMetricDefinition)(item.metricName);
        var min = void 0;
        var max = void 0;
        if (metric.units === "PERCENT") {
          min = 0;
          max = 100;
        } else if (metric.units === "FRACTIONAL_PERCENT") {
          min = 0;
          max = 100;
        } else {
          for (var i = 0; i < item.data.length; i++) {
            var value = item.data[i].value;
            if (min === undefined || min > value) {
              min = value;
            }
            if (max === undefined || max < value) {
              max = value;
            }
          }
          if (min === undefined || max === undefined) {
            continue;
          }
        }
        if (min === undefined) {
          min = 0;
        }
        if (max === undefined) {
          max = min + 100;
        }
        var found = void 0;
        for (var _iterator4 = _createForOfIteratorHelperLoose(unitRanges), _step4; !(_step4 = _iterator4()).done;) {
          var unitRange = _step4.value;
          if (unitRange.units === metric.units) {
            found = unitRange;
            break;
          }
        }
        if (!found) {
          found = {
            units: metric.units,
            min: min,
            max: max
          };
          unitRanges.push(found);
        } else {
          if (found.min > min) {
            found.min = min;
          }
          if (found.max < max) {
            found.max = max;
          }
        }
      }
      return unitRanges.reduce(function (collected, unitRange) {
        collected[unitRange.units] = (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([unitRange.min, unitRange.max]);
        return collected;
      }, {});
    };
    return _this;
  }
  _inheritsLoose(MetricChart, _Component);
  var _proto = MetricChart.prototype;
  _proto.getYAxisCount = function getYAxisCount() {
    var _this$props2 = this.props,
      showYAxis = _this$props2.showYAxis,
      series = _this$props2.series;
    if (!showYAxis) {
      return 0;
    }
    var units = [];
    for (var i = 0; i < series.length; i++) {
      var metricName = series[i].metricName;
      var metric = (0, _Catalogs.getMetricDefinition)(metricName);
      if (!units.includes(metric.units)) {
        units.push(metric.units);
      }
    }
    return units.length;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      _interval = _this$props3.interval,
      series = _this$props3.series,
      width = _this$props3.width,
      height = _this$props3.height,
      xAxisHeight = _this$props3.xAxisHeight,
      yAxisWidth = _this$props3.yAxisWidth,
      padding = _this$props3.padding,
      showXAxis = _this$props3.showXAxis,
      showYAxis = _this$props3.showYAxis,
      showYUnits = _this$props3.showYUnits,
      _showXUnits = _this$props3.showXUnits,
      onClick = _this$props3.onClick,
      time = _this$props3.time;
    var bodyX = 0;
    var bodyY = 0;
    var bodyHeight = height - padding * 2;
    var bodyWidth = width - padding * 2;
    var yAxisCount = this.getYAxisCount();
    if (showXAxis) {
      bodyHeight -= xAxisHeight;
    }
    if (showYAxis) {
      bodyWidth -= yAxisWidth * yAxisCount;
      bodyX += yAxisCount > 0 ? yAxisWidth : 0;
    }
    var xScale = this.createXScale(0, bodyWidth);
    var yScales = this.createYScales(bodyHeight - padding, 0);
    var yAxes = showYAxis && Object.keys(yScales).map(function (units, index) {
      var unitDefinition = (0, _Catalogs.getUnitDefinition)(units);
      var label = unitDefinition.symbol ? unitDefinition.label + " (" + unitDefinition.symbol + ")" : unitDefinition.label;
      var AxisComponent = _Axis.Axis;
      if (units === "MILLISECOND") {
        AxisComponent = _Axis.DurationAxis;
        label = "Duration";
      }
      return /*#__PURE__*/_react["default"].createElement(AxisComponent, {
        key: String(index),
        x: index === 0 ? 0 : bodyWidth + index * yAxisWidth,
        y: 0,
        padding: padding,
        height: height,
        width: yAxisWidth,
        scale: yScales[units],
        orientation: index === 0 ? "LEFT" : "RIGHT",
        label: showYUnits ? label : undefined
      });
    });
    var tickCount = Math.max(2, Math.floor(bodyWidth / 60));
    var _tickFormat = xScale.tickFormat(tickCount);
    return /*#__PURE__*/_react["default"].createElement("svg", {
      width: width,
      height: height,
      onClick: onClick
    }, series.map(normalizeSeries).map(function (item, key) {
      var metric = (0, _Catalogs.getMetricDefinition)(item.metricName);
      var yScale = yScales[metric.units];
      if (!yScale) {
        return null;
      }
      return item.render({
        key: key,
        series: item,
        color: item.color,
        x: bodyX,
        y: bodyY,
        width: bodyWidth,
        height: bodyHeight,
        xScale: xScale,
        yScale: yScale
      });
    }), yAxes, showXAxis && /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
      x: yAxisCount > 0 ? yAxisWidth : 0,
      y: bodyHeight,
      padding: padding,
      height: xAxisHeight,
      width: bodyWidth,
      scale: xScale,
      orientation: "BOTTOM",
      tickFormat: function tickFormat(value) {
        return _tickFormat(time.toPlantDate(value));
      }
    }));
  };
  return MetricChart;
}(_react.Component), _MetricChart.defaultProps = {
  time: undefined,
  padding: 4,
  xAxisHeight: 30,
  yAxisWidth: 60,
  showXAxis: true,
  showYAxis: true,
  showXUnits: true,
  showYUnits: true
}, _MetricChart)) || _class);
function getXValue(input) {
  return Date.parse(input.key);
}
function getYValue(input) {
  return input.value;
}
function getYValuePercent(input) {
  return input.value ? input.value * 100 : 0;
}
function defaultRender(props) {
  return /*#__PURE__*/_react["default"].createElement(_Series.LineChartSeries, props);
}
function normalizeSeries(series) {
  var metric = (0, _Catalogs.getMetricDefinition)(series.metricName);
  return Object.assign({
    getXValue: getXValue,
    getYValue: metric.units === "FRACTIONAL_PERCENT" ? getYValuePercent : getYValue,
    color: metric.color,
    render: defaultRender
  }, series);
}